import { useState } from 'react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import { login, getSession } from '../api/client';

const FONT = '"Public Sans", sans-serif';

const inputStyle = {
  backgroundColor: 'rgba(255, 255, 255, 0.08)',
  border: 'none',
  borderRadius: '9999px',
  height: '48px',
  fontSize: '14px',
  fontFamily: FONT,
  fontWeight: 500,
  color: 'rgba(255, 255, 255, 0.95)',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
};

function PasswordInput({ value, onChange }) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative w-full">
      <input
        type={show ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 pr-12 outline-none"
        style={inputStyle}
      />
      <button
        type="button"
        className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center"
        onClick={() => setShow(!show)}
        style={{
          color: 'rgba(255, 255, 255, 0.5)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          width: '32px',
          height: '32px',
        }}
        aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
      >
        {show ? <IconEyeOff size={18} /> : <IconEye size={18} />}
      </button>
    </div>
  );
}

export default function Login({ onLogin }) {
  const [usuario, setUsuario] = useState(getSession() ? getSession().username : '');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setError('');
    setLoading(true);

    try {
      await login({ username: usuario, password: contrasena });
      onLogin();
    } catch (err) {
      setError(err.message || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div
        className="w-full max-w-md rounded-3xl p-8"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.035)',
          border: '1px solid rgba(255, 255, 255, 0.16)',
        }}
      >
        <div className="flex justify-center mb-8">
          <img src="/logo.png" alt="Nebula POS" className="h-12 w-auto" />
        </div>

        <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-2">
            <label className="text-left" style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.6)', fontFamily: FONT, fontWeight: 500 }}>
              Usuario
            </label>
            <input
              type="text"
              value={usuario}
              onChange={(e) => setUsuario(e.target.value)}
              className="w-full px-4 outline-none"
              style={inputStyle}
            />
          </div>

          <div className="flex flex-col gap-2">
            <label className="text-left" style={{ fontSize: '13px', color: 'rgba(255, 255, 255, 0.6)', fontFamily: FONT, fontWeight: 500 }}>
              Contraseña
            </label>
            <PasswordInput value={contrasena} onChange={setContrasena} />
          </div>

          {error && (
            <p
              className="text-center"
              style={{ fontSize: '13px', color: '#ff453a', fontFamily: FONT }}
            >
              {error}
            </p>
          )}

          <div className="flex flex-col items-center mt-2 gap-4">
            <button
              type="submit"
              disabled={loading}
              className="w-full flex items-center justify-center h-12 rounded-full border-none cursor-pointer touch-manipulation select-none font-semibold transition-colors duration-200 ease-out active:scale-[0.98] [@media(hover:hover)]:hover:bg-[#0077ed]"
              style={{
                backgroundColor: '#0071e3',
                color: '#fff',
                fontSize: '15px',
                letterSpacing: '-0.01em',
                fontFamily: FONT,
                opacity: loading ? 0.6 : 1,
                cursor: loading ? 'wait' : 'pointer',
              }}
            >
              {loading ? 'Verificando...' : 'Iniciar Sesión'}
            </button>
            <a
              href="https://nebula.mindnt.com.mx"
              target="_blank"
              rel="noopener noreferrer"
              className="text-center"
              style={{
                fontSize: '14px',
                color: '#0a84ff',
                fontFamily: FONT,
                fontWeight: 500,
                textDecoration: 'none',
              }}
            >
              ¿Aún no cuentas con una cuenta?
            </a>
          </div>
        </form>
      </div>
    </div>
  );
}